import { tmrResourceFormController } from 'tmr/controllers/resourceForm/resourceForm'
import templateUrl from './form.html'

/**
 * Add ChecklistByUpc route override
 *
 * @namespace routes.ReportChecklistByUpcFormAdd
 * @type {TmrRoute}
 */
let addRoute = {
  name: 'report.checklistsByUpc.add',
  // Workaround for backend capability being different from frontend.
  accessControl: ['Resource.edit', `Resource.Checklist.edit`],
}

/**
 * Edit ChecklistByUpc route override
 *
 * @namespace routes.ReportChecklistByUpcFormEdit
 * @type {TmrRoute}
 */
let editRoute = {
  name: 'report.checklistsByUpc.view.edit',
  // Workaround for backend capability being different from frontend.
  accessControl: ['Resource.edit', `Resource.Checklist.edit`],
}

/**
 * Delete ChecklistByUpc route override
 *
 * @namespace routes.ReportChecklistByUpcDelete
 * @type {TmrRoute}
 */
let deleteRoute = {
  name: 'report.checklistsByUpc.view.delete',
  // Workaround for backend capability being different from frontend.
  accessControl: ['Resource.edit', `Resource.Checklist.edit`],
}

export const routes = [addRoute, editRoute, deleteRoute]

/**
 * Checklist add/edit form component.
 *
 * @type {ngComponent}
 */
export const tmrAdminChecklistByUpcForm = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminChecklistByUpcFormController',
  bindings: {
    resource: '<',
    toast: '<',
  },
}

/**
 * Controller of component {@link tmrAdminChecklistByUpcForm}.
 *
 * @type {ngController}
 */
export class tmrAdminChecklistByUpcFormController extends tmrResourceFormController {
  constructor(
    $scope,
    $state,
    $stateParams,
    TmrInvalidFormError,
    TmrToast,
    Place,
    tmrChecklistOperationTypes
  ) {
    'ngInject'
    super($scope, $state, $stateParams, TmrInvalidFormError, TmrToast)
    Object.assign(this, {
      Place,
      tmrChecklistOperationTypes,
    })
  }

  $onInit() {
    super.$onInit()
    this.resource.type = 'ChecklistByUpcDto'
  }

  addProduct(key, value) {
    this.resource.upcs = this.resource.upcs ?? {}
    this.resource.upcs[key] = value
  }

  removeProduct(key) {
    delete this.resource.upcs[key]
  }

  /** Query to get places for md-autocomplete */
  getPlaces(value) {
    return this.Place.search({ value }).$promise
  }
}
